/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base-call accuracy`)
};

const es_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisión de llamada de base`)
};

const de_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basenaufruf-Genauigkeit`)
};

const nl_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauwkeurigheid van basecalling`)
};

const fr_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précision d'appel de base`)
};

const it_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accuratezza del base-calling`)
};

const pt_br2_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisão da chamada de base`)
};

const pt_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisão de chamada de base`)
};

const ja_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`塩基コール精度`)
};

const zh_phred_accuracy = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`碱基判读准确率`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_accuracy = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_accuracy(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_accuracy", locale)
	if (locale === "en") return en_phred_accuracy(inputs)
	if (locale === "es") return es_phred_accuracy(inputs)
	if (locale === "de") return de_phred_accuracy(inputs)
	if (locale === "nl") return nl_phred_accuracy(inputs)
	if (locale === "fr") return fr_phred_accuracy(inputs)
	if (locale === "it") return it_phred_accuracy(inputs)
	if (locale === "pt-BR") return pt_br2_phred_accuracy(inputs)
	if (locale === "pt") return pt_phred_accuracy(inputs)
	if (locale === "ja") return ja_phred_accuracy(inputs)
	return zh_phred_accuracy(inputs)
};